var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecryptCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 12",
    style: {
      enableBackground: "new 0 0 18 12"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#6A6E7F;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "credit-card",
    transform: "translate(0 -80)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_687",
    className: "st0",
    d: "M17.72,82.83v-0.92c0-1.05-0.85-1.91-1.91-1.91c0,0,0,0,0,0H2.18c-1.05,0-1.91,0.85-1.91,1.91 v0.92c0,0.09,0.07,0.17,0.17,0.17c0,0,0,0,0,0h17.11C17.65,83,17.72,82.92,17.72,82.83C17.72,82.83,17.72,82.83,17.72,82.83z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_688",
    className: "st0",
    d: "M0.28,84.26v5.83c0,1.05,0.85,1.91,1.91,1.91c0,0,0,0,0,0h13.63c1.05,0,1.91-0.85,1.91-1.91l0,0 v-5.83c0-0.09-0.08-0.17-0.17-0.17H0.45C0.35,84.09,0.28,84.17,0.28,84.26z M4.64,88.72c0,0.3-0.24,0.54-0.55,0.54H3.55 c-0.3,0-0.54-0.24-0.55-0.54v-0.54c0-0.3,0.24-0.54,0.55-0.54h0.55c0.3,0,0.54,0.24,0.55,0.54V88.72z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecryptCard);
export default __webpack_public_path__ + "static/media/recrypt_card.4646c0ea.svg";
export { ForwardRef as ReactComponent };